var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rhg-col-12"},[_c('SpaCardsAutoGrid',{attrs:{"title":_vm.title,"cardsData":_vm.spa}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }